import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { GenCodePopupComponent } from '../gen-code-popup/gen-code-popup.component';
import { GenCodeUpdatePopupComponent } from '../gen-code-update-popup/gen-code-update-popup.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-center-codes',
  templateUrl: './center-codes.component.html',
  styleUrls: ['./center-codes.component.scss'],
})
export class CenterCodesComponent implements OnInit {
  gstrVldtMesg: string;
  SessionNo: any;

  constructor(
    private route: ActivatedRoute,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {}

  centerCodesForm: FormGroup;
  MenuCode: string;
  title = 'Title Header';
  title_one = 'Title one Header';
  title_two = 'Title two Header';
  sub_title_one = 'Sub Title One';
  sub_title_two = 'Sub Title Two';
  DistrictList = [];
  CodesList = [];
  submitButton = true;
  selectedDSCode = 0;
  selectedIndex = 0;
  centerCodeCreate=true;
  userPermission: any;
  utp: string;
  dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Center Codes' && element.PCreate == false)
      {
          this.centerCodeCreate = false;  
      }
      
    });
  }
    this.centerCodesForm = this.fb.group({
      Course: new FormControl('', Validators.required),
      Colg: new FormControl(''),
      district: new FormControl(''),
      grace: new FormControl('', Validators.pattern('^[0-9]*$')),
      classGrace: new FormControl('', Validators.pattern('^[0-9]*$')),
      maxClassGrace: new FormControl('', Validators.pattern('^[0-9]*$')),
    });
    this.title = 'Center Codes';
    this.title_one = 'Districts';
    this.sub_title_one = 'Districts List';
    this.title_two = 'Center Codes';
    this.sub_title_two = 'Center Codes List';
    this.loadDistrictGrid();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  loadDistrictGrid() {
    let payload = {};
    this.umsService.getDistrict(payload).subscribe(
      (res) => {
        if (res.status) {
          this.DistrictList = res.data;
        } else {
          this.DistrictList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.DistrictList = [];
      }
    );
  }

  loadCodeListGrid() {
    let payload = {};
    payload['SnNo'] = this.SessionNo;
    this.umsService.getCodeList(payload).subscribe(
      (res) => {
        if (res.status) {
          this.CodesList = res.data;
        } else {
          this.CodesList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.CodesList = [];
      }
    );
  }
  onCourseListSelection(e) {
    this.selectedDSCode = e;
  }

  ValidateAndProcess() {
    let data = {};
    data['message'] =
      'Start Sequence From ' + this.DistrictList[this.selectedDSCode].DsCode;
    data['title'] = 'Sequence District';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        let index;
        let startIndex = this.selectedDSCode;
        if (startIndex !== 0) {
          index = 1;
          for (let i = startIndex; i < this.DistrictList.length; i++) {
            if (this.DistrictList[i].DsCode === this.selectedDSCode) {
              this.DistrictList[i].Dist = index;
              index++;
            } else {
              this.DistrictList[i].Dist = index;
              index++;
            }
          }
          for (let i = 0; i < startIndex; i++) {
            this.DistrictList[i].Dist = index;
            index++;
          }
        } else {
          this.DistrictList.forEach((element, i) => {
            element['Dist'] = i + 1;
          });
        }
      }
    });
  }

  generateCode() {
    let data = {};
    this.dialogRef = this.dialog.open(GenCodePopupComponent, {
      width: '500px',
      height: 'auto',
      data,
    });
    this.dialogRef.afterClosed().subscribe((result) => {
      let code = result.code;
      if(result.status == 'yes'){
        let data = {};
        data['message'] = "Center Codes Will Be Assigned From "+result.code+ " In Order of District Seq and Center Name Proceed" 
        data['title'] = 'Generate Codes';
        data['icon'] = 'fa fa-question';
        this.dialogRef =
          this.modalPopupService.openPopup<ConformationModelComponent>(
            ConformationModelComponent,
            data
          );
        this.dialogRef.afterClosed().subscribe((result) => {
          if (result === 'yes') {
            this.DistrictList.forEach(element => {
              let payload = {}
              payload['DsCode'] = element['DsCode'];
              payload['DsSpFlag'] = element['Dist'].toString().padStart(4,'0')
              this.umsService.UpdateCodeDistrict(payload).subscribe(
                (ERROR: HttpErrorResponse) => {
                  // this.CodesList = [];
                }
              );
            });
            let payload = {};
            payload['SnNo'] =  this.SessionNo
            payload['GcSrNo'] = code;
            payload['Inst'] =  sessionStorage.getItem('Inst');            
            this.umsService.createGenCent(payload).subscribe(
              (res) => {
                 // show created popup
                this.loadCodeListGrid();
              },
              (ERROR: HttpErrorResponse) => {
                // show error popup
                // this.CodesList = [];
                
              }
            );
          }
        })

      }else if(result.status == 'no'){
        // popup saying process canceled by user
      }
    });
  }

  editGeneratedCode(course){
    let data = {};
    this.dialogRef = this.dialog.open(GenCodeUpdatePopupComponent, {
      width: '500px',
      height: 'auto',
      data,
    });
    this.dialogRef.afterClosed().subscribe((result) => {
      let code = result.code;
      if(result.status == 'yes'){
        let payload = {};
        payload['SnNo'] =  this.SessionNo
        payload['GcCode'] = code.toString().padStart(4,'0') ;
        payload['CgCode'] = course.CgCode ;
        // important - Inst
        this.umsService.updateGenCent(payload).subscribe(
          (res) => {
            // show updated popup
            this.loadCodeListGrid();
          },
          (ERROR: HttpErrorResponse) => {
            // show error popup
          }
        );
      }else if(result.status == 'no'){
        // popup saying process canceled by user
      }
    });
  }

  keypress(){

  }

  print(){
    let submitpayload = this.centerCodesForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'Centre-Codes';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 123,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  
  redirect(to): void {
    this.router.navigate([to]);
  }
}